/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";
import { labellessButtonCss } from "./styles";

type Props = PurposedButtonProps & {
  tooltip?: string;
};

const SearchButton = (props: Props) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      tooltip={props.tooltip || formatMessage({ id: "common.search" })}
      iconName="search"
      css={labellessButtonCss}
      dataCy="search-button"
      {...props}
    />
  );
};

export default SearchButton;
